import { render, staticRenderFns } from "./ListarRelatoriosDeLogDeConfiguracaoEdicao.vue?vue&type=template&id=67dbd46f&"
import script from "./ListarRelatoriosDeLogDeConfiguracaoEdicao.vue?vue&type=script&lang=js&"
export * from "./ListarRelatoriosDeLogDeConfiguracaoEdicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDataTable,VForm,VRow})
